import { Link } from "react-router-dom";
import { useTenant } from "../../../Contexts/TenantContext";
import { PolicyType } from "../../../Enums/PolicyType";
import { toPublicPath } from "../../../Utils/publicRoutes";
import { InfoBox } from "../../../Components/InfoBox/InfoBox";
import SmartNavbar from "../../../Components/SmartNavbar/SmartNavbar";
import Banner from "../../../Components/Banner/Banner";
import PoliciesLinks from "../../../Components/PoliciesLinks/PoliciesLinks";
import PolicyAccordionItem from "../../../Components/PolicyAccordionItem/PolicyAccordionItem";
import Footer from "../../../Components/Footer/Footer";

const UserFaqPage = () => {
  const { tenant } = useTenant();
  const signInPath = toPublicPath("/login");
  return (
    <div>
      <SmartNavbar />
      <div className={`w-full bg-gray-50`}>
        <Banner
          title={"Perguntas Frequentes"}
          description={`Tire todas as suas dúvidas sobre a ${tenant?.companyName} aqui, confira nossas perguntas frequentes sobre cadastro, compra, entrega e outros assuntos, e se não encontrar o que estava procurando, você também pode entrar em contato com o nosso atendimento por email ou telefone.`}
        />
        <div className={`w-full flex flex-col md:flex-row gap-4 md:gap-6 page-gutter py-6 xl:px-36`}>
          <div className="flex md:hidden justify-between mb-4">
            <PoliciesLinks excludedPolicy={PolicyType.Faq} isMobile />
          </div>

          <div className={`hidden md:block flex-[0.4] `}>
            <PoliciesLinks excludedPolicy={PolicyType.Faq} />
          </div>

          <div className={`flex flex-col flex-[1.6] gap-2 md:gap-4 `}>
            <h2 className="text-md md:text-xl text-gray-800 font-bold my-2 md:my-3">{"Meu cadastro"}</h2>
            <PolicyAccordionItem
              title={"Para alterar meu e-mail ou senha, o que devo fazer?"}
              content={
                <>
                  <div className="text-xs md:text-sm text-gray-800 leading-normal md:text-justify">
                    <p className="mb-5">
                      {"Para alterar o seu e-mail ou senha, siga os passos abaixo:"}
                    </p>
                    <p className="mb-1">
                      - <Link to={signInPath} className="text-primary-600 font-semibold hover:underline">
                          {"Clique aqui"}
                        </Link> {"e faça login na sua conta."}
                    </p>
                    <p className="mb-1">
                      - {"Acesse o"} <strong>{"menu"}</strong> {"e selecione"} <strong>'{"Meus dados"}'</strong>.
                    </p>
                    <p className="mb-1">
                      - {"Clique em"} <strong>'{"ALTERAR E-MAIL"}'</strong> {"ou"} <strong>'{"ALTERAR SENHA"}'</strong>.
                    </p>
                    <p className="mb-5">
                      - {"Siga as etapas."}
                    </p>
                  </div>

                  <InfoBox type="warning">
                    {"Será necessário inserir um código de verificação que será enviado para o seu e-mail cadastrado para prosseguir com a alteração."}
                  </InfoBox>
                </>
              }
            />

            <PolicyAccordionItem
              title={"Como posso alterar ou cadastrar um novo endereço?"}
              content={
                <>
                  <div className="text-xs md:text-sm text-gray-800 leading-normal md:text-justify">
                    <p className="mb-5">
                      <Link to={signInPath} className="text-primary-600 font-semibold hover:underline">
                        {"Clique aqui"}
                      </Link> {"e faça login na sua conta para realizar as alterações de"} <strong>{"Endereços"}</strong>.
                    </p>
                    <p className="mb-1">
                      <strong>{"Cadastrar novo endereço:"}</strong>
                    </p>
                    <p className="mb-5">
                      - {"Clique em"} <strong>'{"CADASTRAR NOVO ENDEREÇO"}'</strong>, {"preencha todos os dados e finalize clicando em"} <strong>'{"Salvar alterações"}'</strong>.
                    </p>
                    <p className="mb-1">
                      <strong>{"Editar endereço já cadastrado:"}</strong>
                    </p>
                    <p>
                      - {"Selecione o endereço já cadastrado e clique em"} <strong>'{"EDITAR"}'</strong>, {"após finalizar clique em"} <strong>'{"Salvar alterações"}'</strong>.
                    </p>
                  </div>
                </>
              }
            />

            <PolicyAccordionItem
              title={"Como posso alterar meu nome e telefone?"}
              content={
                <>
                  <div className="text-xs md:text-sm text-gray-800 leading-normal md:text-justify">
                    <p className="mb-5">
                      {"Para alterar o seu nome ou telefone, siga os passos abaixo:"}
                    </p>
                    <p className="mb-1">
                      - <Link to={signInPath} className="text-primary-600 font-semibold hover:underline">
                          {"Clique aqui"}
                        </Link> {"e faça login na sua conta."}
                    </p>
                    <p className="mb-1">
                      - {"Acesse o"} <strong>{"menu"}</strong> {"e selecione"} <strong>'{"Meus dados"}'</strong>.
                    </p>
                    <p className="mb-1">
                      - {"Edite o campo"} <strong>'{"Nome completo"}'</strong> {"ou"} <strong>'{"Telefone celular"}'</strong>.
                    </p>
                    <p className="mb-5">
                      - {"Clique em"} <strong>'{"Salvar alterações"}'</strong>.
                    </p>
                  </div>

                  <InfoBox type="warning">
                    {"O campo 'Nome completo' só existe para contas do tipo Pessoa Física, mas o campo 'Telefone celular' existe para ambos os tipos de conta."}
                  </InfoBox>
                </>
              }
            />

            <h2 className="text-md md:text-xl text-gray-800 font-bold my-2 md:my-3">{"Pagamento"}</h2>
            <PolicyAccordionItem
              title={"Qual é o prazo para confirmação de pagamento?"}
              content={
                <>
                  <div className="text-xs md:text-sm text-gray-800 leading-normal md:text-justify">
                    <p className="mb-1">
                      {"A confirmação do seu pagamento varia de acordo com o método escolhido:"}
                    </p>
                    <p className="mb-1">
                      <strong>{"Boleto bancário:"}</strong> {"A confirmação ocorre em até 2 dias úteis."}
                    </p>
                    <p className="mb-1">
                      <strong>{"Cartão de crédito:"}</strong> {"O prazo para confirmação é de até 3 dias úteis. Fique atento ao e-mail e telefone cadastrados, pois podemos precisar confirmar dados para liberar seu pedido."}
                    </p>
                    <p className="mb-5">
                      <strong>{"PIX:"}</strong> {"A confirmação é quase instantânea, levando até 30 minutos."}
                    </p>
                  </div>

                  <InfoBox type="warning">
                    {"Se o pagamento permanecer pendente após esse período, entre em contato com nosso Atendimento."}
                  </InfoBox>
                </>
              }
            />

            <PolicyAccordionItem
              title={"Como comprar usando o PIX?"}
              content={
                <>
                  <div className="text-xs md:text-sm text-gray-800 leading-normal md:text-justify">
                    <p className="mb-5">
                      <strong>{"Até 10% de desconto com o PIX!"}</strong>
                    </p>
                    <p>
                      {"Finalize a compra para gerar o QR Code."}
                    </p>
                    <p>
                      {"No app do banco, selecione PIX e escaneie o QR Code."}
                    </p>
                    <p className="mb-5">
                      {"Ou copie o código PIX 'Copia e Cola' no app do seu banco."}
                    </p>
                  </div>

                  <InfoBox type="warning">
                    {"Atenção: O QR Code gerado após a finalização do pedido é válido por 24 horas."}
                  </InfoBox>
                </>
              }
            />

            <h2 className="text-md md:text-xl text-gray-800 font-bold my-2 md:my-3">{"Meu Pedido"}</h2>
            <PolicyAccordionItem
              title={"Como verificar o status do meu pedido?"}
              content={
                <>
                  <div className="text-xs md:text-sm text-gray-800 leading-normal md:text-justify">
                    <p className="mb-5">
                      {"O status do pedido pode ser consultado na tela de pedidos."}
                    </p>
                  </div>

                  <InfoBox type="warning">
                    {"Em caso de qualquer problema, entraremos em contato pelos dados de contato cadastrados. Mantenha seu e-mail e telefone sempre atualizados."}
                  </InfoBox>
                </>
              }
            />

            <PolicyAccordionItem
              title={"Posso alterar o endereço de entrega se o pedido já estiver em transporte?"}
              content={
                <>
                  <div className="text-xs md:text-sm text-gray-800 leading-normal md:text-justify">
                    <p className="mb-5">
                      {"Se seu pedido já estiver em transporte, não é possível alterar o endereço de entrega diretamente. No entanto, você pode entrar em contato com a gente para verificar a possibilidade de solicitar o retorno do pedido para prosseguirmos com o cancelamento."}
                    </p>
                  </div>

                  <InfoBox type="warning">
                    {"Lembre-se: com o pedido em transporte, nossa equipe só pode verificar a possibilidade de retorno, não alterar o endereço. Por isso, é importante conferir todos os dados do endereço antes da abertura de pedido."}
                  </InfoBox>
                </>
              }
            />

            <PolicyAccordionItem
              title={"Como cancelar meu pedido?"}
              content={
                <>
                  <div className="text-xs md:text-sm text-gray-800 leading-normal md:text-justify">
                    <p className="mb-1">
                      <strong>{"Pedido aguardando ação do cliente ou de nossa equipe:"}</strong> {'O pedido pode ser cancelado clicando em "CANCELAR PEDIDO" no respectivo pedido por meio da tela de pedidos.'}
                    </p>
                    <p className="mb-1">
                      <strong>{"Pedido em rota de entrega:"}</strong> {"Não é possível cancelar pedidos que já estão em rota de entrega. A única opção é entrar em contato conosco."}
                    </p>
                    <p className="mb-5">
                      <strong>{"Pedido aguardando aprovação do cartão de crédito:"}</strong> {`A ${tenant?.companyName} tenta aprovar o pedido com a administradora do cartão por até 48 horas. Se não houver aprovação, o pedido será cancelado automaticamente sem novas tentativas.`}
                    </p>
                  </div>

                  <InfoBox type="warning">
                    {"Lembre-se: após a liberação para o pagamento do pedido, você possui até 48 horas para concluir o pagamento, após esse período, o pedido será cancelado automaticamente."}
                  </InfoBox>
                </>
              }
            />

            <h2 className="text-md md:text-xl text-gray-800 font-bold my-2 md:my-3">{"Pagamento de frete ou taxas adicionais"}</h2>
            <PolicyAccordionItem
              title={"Pagamento de frete ou taxas adicionais. Isso é normal?"}
              content={
                <>
                  <div className="text-xs md:text-sm text-gray-800 leading-normal md:text-justify">
                    <p className="mb-5">
                      {"Não! A"}<strong>{tenant?.companyName}</strong> {"não envia"} <strong>{"cobranças adicionais"}</strong> {"por fora do processo de compra em nosso site."}
                    </p>
                    <p className="mb-5">
                      {"Todas as cobranças referentes aos pedidos são realizadas exclusivamente no ambiente"} {tenant?.companyName}, {"e nossos"} <strong>{"transportadores não fazem nenhum tipo de cobrança direta ao cliente"}</strong>.
                    </p>
                  </div>

                  <InfoBox type="warning">
                    {"Se você receber qualquer mensagem, SMS, WhatsApp ou e-mail solicitando pagamentos extras (como taxas de importação, frete adicional etc.), desconsidere a comunicação."}
                  </InfoBox>
                </>
              }
            />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default UserFaqPage;
